export class Config {

    public static baseURL: string = "https://krabicky-test.unknown.cz/rest";

    public static theme = {
        typography: {
          useNextVariants: true,
        },
        palette: {
          primary: {
            main: "#3f51b5"
          }
        }
      };

}


// WEBPACK FOOTER //
// ./src/Config.tsx